import React, {useState, useEffect, useRef} from 'react';
import {shallowEqual, useSelector, useDispatch} from 'react-redux';
import TableList from 'src/app/components/TableList';
import {
  Form,
  Input,
  Select,
  Spin,
  DatePicker,
  Checkbox,
  Tabs,
  InputNumber,
  Tooltip,
  Popconfirm,
} from 'antd';
import {Modal, Button} from 'react-bootstrap';
import {toast} from 'react-toastify';
import * as authHelper from 'src/app/modules/auth/core/AuthHelpers';
import * as actionsModal from 'src/setup/redux/modal/Actions';
import {
  requestPOST,
  requestGET,
  requestPUT,
  API_URL,
  FILE_URL,
  requestDELETE,
} from 'src/utils/baseAPI';
import * as actionsGlobal from 'src/setup/redux/global/Actions';
import {useAuth} from 'src/app/modules/auth';
import {useIntl} from 'react-intl';
import moment from 'moment';
import Collapse from 'react-bootstrap/Collapse';
import {Typography} from 'antd';

const FormItem = Form.Item;
const {Option} = Select;

const {TextArea} = Input;

const {Text} = Typography;
const ModalItem = (props) => {
  const dispatch = useDispatch();
  const {currentUser} = useAuth();
  const intl = useIntl();
  const {setModalSyncConfig, modalSyncConfig} = props;

  const dataModal = useSelector((state) => state.modal.dataModal);
  const id = dataModal?.id ?? null;

  const [form] = Form.useForm();
  const [loadding, setLoadding] = useState(false);
  const [settingConfig, setSettingConfig] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const res = await requestGET(`api/v1/syncs/getconfig`);
      if (res && res.data) {
        setSettingConfig(res.data);
      }
    };
    fetchData();

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCancel = () => {
    form.resetFields();
    setModalSyncConfig(false);
  };

  const onFinish = async () => {
    // try {
    //   const formData = form.getFieldsValue(true);
    //   formData.userId = currentUser.id;
    //   const res = await requestPOST(`api/v1/settingconfigs/creatupdate`, formData);
    //   if (res) {
    //     toast.success(intl.formatMessage({id: 'LOG.UPDATESUCESSFUL'}));
    //     dispatch(actionsGlobal.setChooseBranch(false));
    //     handleCancel();
    //   } else {
    //     toast.error(intl.formatMessage({id: 'LOG.UPDATEFAILED'}));
    //   }
    // } catch (errorInfo) {
    //   // console.log('Failed:', errorInfo);
    // }
    handleCancel();
  };
  const normalizeInput = (value) => {
    if (!value) return value;
    return value.toUpperCase();
  };

  const handleSynczk = async () => {
    const res = await requestPOST(`api/v1/backupdatas/sync`, {});
    if (res) {
      toast.success('Đồng bộ thành công!');
    }
  };

  const itemTabs = [
    {
      key: '1',
      label: 'Đồng bộ dữ liệu',
      children: <TabSyncData settingConfig={settingConfig} />,
    },
    {
      key: '2',
      label: 'Đồng bộ ảnh',
      children: <TabSyncImage settingConfig={settingConfig} />,
    },
  ];

  const onChange = (key) => {};

  return (
    <Modal
      show={modalSyncConfig}
      fullscreen={'lg-down'}
      onExited={handleCancel}
      keyboard={true}
      scrollable={true}
      onEscapeKeyDown={handleCancel}
      size='lg'
    >
      <Modal.Header className='bg-primary px-4 py-3'>
        <Modal.Title className='text-white'>Cấu hình đồng bộ </Modal.Title>
        <button
          type='button'
          className='btn-close btn-close-white'
          aria-label='Close'
          onClick={handleCancel}
        ></button>
      </Modal.Header>
      <Modal.Body>
        <Spin spinning={loadding}>
          {!loadding && (
            <Form form={form} layout='vertical' /* initialValues={initData} */ autoComplete='off'>
              <div className='row'>
                <div className='col-xl-12 col-lg-12'>
                  <Tabs defaultActiveKey='1' items={itemTabs} onChange={onChange} />
                </div>
              </div>
            </Form>
          )}
        </Spin>
      </Modal.Body>
      <Modal.Footer className='bg-light px-4 py-2 align-items-center'>
        <div className='d-flex justify-content-center  align-items-center'>
          <Button className='btn-sm btn-primary rounded-1 p-2  ms-2' onClick={onFinish}>
            <i className='fa fa-save'></i>
            Đóng
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const TabSyncData = (props) => {
  const {settingConfig} = props;
  const [jobData, setJobData] = useState(null);
  const [open, setOpen] = useState(false);
  const [minute, setMinute] = useState(5);
  const random = useSelector((state) => state.modal.random);
  const dispatch = useDispatch();
  const [dataJobs, setDataJobs] = useState(null);
  const [size, setSize] = useState(10);
  const [count, setCount] = useState(0);
  const [offset, setOffset] = useState(1);
  const [syncTime, setSyncTime] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const rs = await requestGET('api/v1/syncs/DongBoDuLieu');

      if (rs) {
        setJobData(rs);
      } else {
        setJobData(null);
      }
    };
    fetchData();
  }, [random]);

  const handleFinish = () => {
    let cronTime = numberToCron(minute);
    const fetchData = async () => {
      const rs = await requestPOST('api/v1/syncs/create-job-data', {
        cronExpression: cronTime,
        syncTime: syncTime,
      });
      if (rs) {
        toast.success('Thành công!');
        dispatch(actionsModal.setRandom());
      }
    };
    fetchData();
  };

  const handleRunJob = async () => {
    const rs = await requestGET('api/v1/syncs/run-syncdata');
    if (rs) {
      toast.success('Đồng bộ dữ liệu thành công!');
    } else {
      toast.error('Đồng bộ dữ liệu không thành công!');
    }
  };
  const handleDeleteJob = async (jobId) => {
    const rs = await requestDELETE(`api/v1/syncs/delete/${jobId}`);
    if (rs) {
      dispatch(actionsModal.setRandom());
      setOpen(false);
      toast.success('Xóa job thành công!');
    }
  };

  useEffect(() => {
    const fetchJobData = async () => {
      const rs = await requestPOST('api/v1/syncs/searchlog', {
        pageNumber: offset,
        pageSize: size,
      });
      setDataJobs(rs?.data ?? []);
      setCount(rs?.totalCount ?? 0);
    };

    if (jobData) {
      fetchJobData();
    }
  }, [jobData, offset, count, size]);

  const columns = [
    {
      title: 'Stt',
      dataIndex: '',
      key: 'stt',
      render: (id, record, index) => {
        ++index;
        return index;
      },
      showSorterTooltip: false,
    },
    {
      title: 'Thời gian',
      dataIndex: 'createdOn',
      key: 'createdOn',
      render: (id, record) => <span>{moment(record.createdOn).format('DD/MM/YYYY HH:mm')}</span>,
    },
    {
      title: 'Trạng thái',
      dataIndex: '',
      key: '',
      render: (id, record) => (
        <div className={`badge badge-light-${record?.status ? 'success' : 'danger'}`}>
          {record?.status ? 'Thành công' : 'Thất bại'}
        </div>
      ),
    },
    {
      title: 'Ghi chú',
      dataIndex: 'description',
      key: 'description',
    },
  ];

  const changeSyncTime = (e) => {
    setSyncTime(moment(e).add(7, 'hours'));
  };
  return (
    <Form layout='vertical' /* initialValues={initData} */ autoComplete='off'>
      <div className='col-xl-6 col-lg-6'>
        <FormItem label='Cấu hình đường dẫn'>
          <Input value={settingConfig?.server}></Input>
        </FormItem>
      </div>
      <div className='col-xl-6 col-lg-6'>
        <FormItem label='Tenant'>
          <Input value={settingConfig?.tenantId}></Input>
        </FormItem>
      </div>

      {jobData ? (
        <>
          <div className='col-xl-6 col-lg-6'>
            <FormItem label='Thời gian tạo'>
              <InputNumber
                value={moment(jobData?.createdAt).format('YYYY/MM/DD HH:mm')}
              ></InputNumber>
            </FormItem>
          </div>
          <div className='col-xl-6 col-lg-6' name='minute'>
            <FormItem label='Thời gian đồng bộ(Phút)'>
              <InputNumber
                min={2}
                max={59}
                defaultValue={cronToNumber(jobData?.cron)}
              ></InputNumber>
            </FormItem>
            <i>Nếu muốn sửa thời gian hãy xóa đi tạo lại</i>
          </div>

          {/* <FormItem label='Lần đồng bộ gần nhất'>
              <Input
                value={
                  jobData?.lastExecution
                    ? moment(jobData?.lastExecution).format('HH:mm:ss')
                    : 'Chưa có'
                }
              ></Input>
            </FormItem> */}
          <div className='col-xl-6 col-lg-6'>
            <FormItem label='Lần đồng bộ tiếp theo'>
              <Input value={moment(jobData?.nextExecution).format('HH:mm:ss')}></Input>
            </FormItem>
          </div>

          <Button type='button' onClick={handleRunJob} variant='success'>
            Chạy ngay lập tức
          </Button>

          <Popconfirm
            title='Xóa Job'
            onConfirm={() => handleDeleteJob('DongBoDuLieu')}
            okText='Xóa'
            cancelText='Hủy'
          >
            <Button type='button' variant='danger' style={{marginLeft: 10}}>
              Xóa
            </Button>
          </Popconfirm>

          {jobData && (
            <>
              <h1 style={{marginTop: 20}}>Kết quả đồng bộ</h1>

              <div className='card-dashboard-body table-responsive'>
                <TableList
                  dataTable={dataJobs}
                  columns={columns}
                  isPagination={true}
                  size={size}
                  count={count}
                  setOffset={setOffset}
                  setSize={setSize}
                />
              </div>
            </>
          )}
        </>
      ) : (
        <>
          {!open ? (
            <>
              <p>Chưa có Job đồng bộ</p>

              <Button type='button' onClick={() => setOpen(true)}>
                Tạo mới
              </Button>
            </>
          ) : (
            <>
              <div className='card card-body'>
                <Tooltip title='Đây là ghi chú' />
                <div className='col-xl-6 col-lg-6'>
                  <FormItem label='Thời gian đồng bộ(Phút)'>
                    <InputNumber
                      initialValues={5}
                      defaultValue={5}
                      onChange={(e) => setMinute(e.target.value)}
                    ></InputNumber>
                  </FormItem>
                </div>
              </div>
              <div className='col-xl-6 col-lg-6'>
                <FormItem label='Mốc thời gian đồng bắt đầu đồng bộ(nên backup từ máy chính sang rồi và chọn mốc lúc backup)'>
                  <DatePicker
                    placeholder=''
                    format={'DD/MM/YYYY HH:mm'}
                    onChange={changeSyncTime}
                  />
                </FormItem>
              </div>

              <Button type='button' onClick={handleFinish}>
                Hoàn tất
              </Button>
            </>
          )}
        </>
      )}
    </Form>
  );
};

const TabSyncImage = (props) => {
  const {settingConfig} = props;
  const [jobData, setJobData] = useState(null);
  const [open, setOpen] = useState(false);
  const [minute, setMinute] = useState(5);
  const random = useSelector((state) => state.modal.random);
  const dispatch = useDispatch();
  const [folderLocalStatus, setFolderLocalStatus] = useState(null);
  const [folderRemoteStatus, setFolderRemoteStatus] = useState(null);
  const [syncTime, setSyncTime] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const rs = await requestGET('api/v1/syncs/DongBoAnh');

      if (rs) {
        setJobData(rs);
      } else {
        setJobData(null);
      }
    };
    fetchData();
  }, [random]);

  const handleFinish = () => {
    let cronTime = numberToCron(minute);
    console.log(syncTime);
    const fetchData = async () => {
      const rs = await requestPOST('api/v1/syncs/create-job-image', {
        cronExpression: cronTime,
        syncTime: syncTime,
      });
      if (rs) {
        toast.success('Thành công!');
        dispatch(actionsModal.setRandom());
      }
    };
    fetchData();
  };

  const handleRunJob = async () => {
    const rs = await requestGET('api/v1/syncs/run-syncimage');
    if (rs) {
      toast.success('Đồng bộ ảnh thành công!');
    } else {
      toast.error('Đồng bộ ảnh không thành công!');
    }
  };
  const handleDeleteJob = async (jobId) => {
    const rs = await requestDELETE(`api/v1/syncs/delete/${jobId}`);
    if (rs) {
      dispatch(actionsModal.setRandom());
      setOpen(false);
      toast.success('Xóa job thành công!');
    }
  };

  const handleTestFolder = async (path, type) => {
    const rs = await `aprequestGETi/v1/syncs/testfolder/${path}`;
    switch (type) {
      case 0:
        if (rs) {
          setFolderLocalStatus(true);
        } else {
          setFolderLocalStatus(false);
        }
        break;
      case 1:
        if (rs) {
          setFolderRemoteStatus(true);
        } else {
          setFolderRemoteStatus(false);
        }
        break;
      default:
        break;
    }
  };

  const changeSyncTime = (e) => {
    setSyncTime(moment(e).add(7, 'hours'));
  };

  return (
    <Form layout='vertical' /* initialValues={initData} */ autoComplete='off'>
      <div className='row'>
        <div className='col-xl-6 col-lg-6'>
          <FormItem label='Cấu hình folder ảnh máy phụ'>
            <Input value={settingConfig?.localUrl}></Input>
          </FormItem>
        </div>

        <div className='col-xl-4 col-lg-4'>
          <FormItem label='Test'>
            <Button variant='primary' onClick={() => handleTestFolder(settingConfig?.localUrl, 0)}>
              Test
            </Button>

            <div className={`badge badge-light-${true ? 'success' : 'danger'}`}>
              {folderLocalStatus == true
                ? 'Thành công'
                : folderLocalStatus == false
                ? 'Thất bại'
                : ''}
            </div>
          </FormItem>
        </div>

        <div className='col-xl-6 col-lg-6'>
          <FormItem label='Cấu hình folder ảnh máy chính'>
            <Input value={settingConfig?.remoteUrl}></Input>
          </FormItem>
        </div>

       

        <div className='col-xl-4 col-lg-4'>
          <FormItem label='Test'>
            <Button variant='primary' onClick={() => handleTestFolder(settingConfig?.localUrl, 1)}>
              Test
            </Button>

            <div className={`badge badge-light-${true ? 'success' : 'danger'}`}>
              {folderRemoteStatus == true
                ? 'Thành công'
                : folderRemoteStatus == false
                ? 'Thất bại'
                : ''}
            </div>
          </FormItem>
        </div>

        <div className='col-xl-6 col-lg-6'>
          <FormItem label='UserName máy chính'>
            <Input value={settingConfig?.userName}></Input>
          </FormItem>
        </div>

        <div className='col-xl-6 col-lg-6'>
          <FormItem label='Password máy chính'>
            <Input value={settingConfig?.password}></Input>
          </FormItem>
        </div>

        <div className='col-xl-6 col-lg-6'>
          {jobData ? (
            <>
              <FormItem label='Thời gian tạo'>
                <Input value={moment(jobData?.createdAt).format('YYYY/MM/DD HH:mm')}></Input>
              </FormItem>

              <FormItem label='Thời gian đồng bộ(Phút)'>
                <InputNumber
                  min={2}
                  max={59}
                  defaultValue={cronToNumber(jobData?.cron)}
                ></InputNumber>
              </FormItem>
              <i>Nếu muốn sửa thời gian hãy xóa đi tạo lại</i>
              <FormItem label='Lần đồng bộ tiếp theo'>
                <Input value={moment(jobData?.nextExecution).format('HH:mm:ss')}></Input>
              </FormItem>
              <Button type='button' onClick={handleRunJob} variant='success'>
                Chạy ngay lập tức
              </Button>

              <Popconfirm
                title='Xóa Job'
                onConfirm={() => handleDeleteJob('DongBoAnh')}
                okText='Xóa'
                cancelText='Hủy'
              >
                <Button type='button' variant='danger' style={{marginLeft: 10}}>
                  Xóa
                </Button>
              </Popconfirm>
            </>
          ) : (
            <>
              {!open ? (
                <>
                  <p>Chưa có Job đồng bộ</p>
                  <Button type='button' onClick={() => setOpen(true)}>
                    Tạo mới
                  </Button>
                </>
              ) : (
                <>
                  <div className='card card-body'>
                    <Tooltip title='Đây là ghi chú' />

                    <FormItem label='Thời gian đồng bộ(Phút)' name='minute'>
                      <InputNumber
                        initialValues={5}
                        defaultValue={5}
                        onChange={(e) => setMinute(e.target.value)}
                      ></InputNumber>
                    </FormItem>
                  </div>
                  <FormItem label='Ngày bắt đầu'>
                    <DatePicker placeholder='' format={'DD/MM/YYYY'} onChange={changeSyncTime} />
                  </FormItem>
                  <Button type='button' onClick={handleFinish}>
                    Hoàn tất
                  </Button>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </Form>
  );
};

export default ModalItem;

function cronToNumber(cronExpression) {
  const parts = cronExpression.split(' ');
  const minutePart = parts[0];

  if (minutePart.startsWith('*/')) {
    return parseInt(minutePart.replace('*/', ''), 10);
  }
  return null;
}

function numberToCron(number) {
  return `*/${number} * * * *`; // Tạo cron expression với số phút là number
}
